<script>
  import { getContext } from 'svelte'
  import { cssPrefix } from '../helper-classes.js'

  export let selected = false
  export let selectable = true

  const { selector, onSelect } = getContext('currentDropdownList')
  const dropdown = getContext('currentDropdown')

  const index = selectable ? selector.addSelectable(selected) : 0

  const handleSelect = () => {
    if (!selectable) return
    selector.select(index)
    onSelect(index)
    if (dropdown && dropdown.opened) dropdown.opened.set(false)
  }
</script>

<!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
<li
  class={`${cssPrefix}dropdown-item`}
  class:is-selected={$selector[index]}
  on:click={handleSelect}
  on:keypress={e => {
    if (e.key === 'Enter') {
      handleSelect()
    }
  }}
>
  <slot />
</li>
